import { Button } from "primereact/button";
import styled from "styled-components";
import { device } from "../../../constants/mediaQueries";
import { ControlledMenu } from "@szhsin/react-menu";

const desktopMenuWidth = "270px";

export const StyledProfileBtn = styled(Button)`
  &.cvp-profile-btn {
    &.p-button.p-button-icon-only {
      width: 2rem;
      padding: 0.45rem 0;

      @media ${device.md} {
        width: 2.357rem;
        padding: 0.5rem 0;
      }
    }

    .pi {
      font-size: 0.9rem;

      @media ${device.md} {
        font-size: 1rem;
      }
    }

    background-color: var(--primary-100-relative);
    border: none;
    color: var(--primary-500);

    &:hover:not(:disabled) {
      background-color: var(--primary-50-relative);
      color: var(--primary-300-relative);
    }
    &:active:not(:disabled) {
      border: none;
    }
    &:focus:not(:disabled) {
      box-shadow: none;
    }
  }
`;

export const StyledProfileDropdown = styled.div`
  display: flex;
  gap: 1.5rem;
  border: 1px solid var(--primary-100-relative);
  border-radius: 4px;
  padding: 0.2rem 0.5rem;
  width: ${desktopMenuWidth};

  .pi-user {
    font-size: 0.9rem;
    background-color: var(--primary-100-relative);
    border-radius: 4px;
    color: var(--primary-500);
    padding: 0.5rem;
    @media ${device.md} {
      font-size: 1rem;
    }
  }

  &:hover {
    cursor: pointer;
  }
`;

export const StyledSimpleProfileDropdown = styled.div`
  .pi-user {
    font-size: 0.9rem;
    background-color: var(--primary-100-relative);
    border-radius: 4px;
    color: var(--primary-500);
    padding: 0.5rem;
    @media ${device.md} {
      font-size: 1rem;
    }
  }

  &:hover {
    cursor: pointer;
  }
`;

export const StyledReactControlledMenu = styled(ControlledMenu)`
  &.cvp-react-menu > .szh-menu {
    padding: 0.3rem 0 0 0;
    width: 230px;

    transform-origin: top center;

    @media ${device.md} {
      width: ${desktopMenuWidth};
    }
  }

  .szh-menu {
    background: var(--surface-a);
    border: var(--popup-border-thickness) solid var(--surface-d);
  }

  .szh-menu__item {
    padding: 0.7rem 1rem;
    font-size: 0.9rem;
    gap: 0.5rem;
    width: 100%;
    color: var(--text-color);

    &.vpn-item {
      color: var(--red-500);
    }

    &.vpn-item.vpn-only {
      padding: 0.35rem 0.5rem;
      margin: 0.35rem 0.5rem;
      width: auto;
    }

    &--anchor {
      color: var(--text-color);
      text-decoration: none;
    }

    &--hover {
      background: var(--primary-50-relative);
      -webkit-transition: all ease-out 0.3s;
      -moz-transition: all ease-out 0.3s;
      -o-transition: all ease-out 0.3s;
      transition: all ease-out 0.3s;
    }
  }

  .szh-menu__item.szh-menu__item.guid {
    padding: 0.3rem 1rem;
    font-size: 0.7rem;
    color: var(--text-color-secondary);
    background-color: var(--surface-100);
    border-bottom-left-radius: 0.25rem;
    border-bottom-right-radius: 0.25rem;

    i {
      font-size: 0.7rem;
    }
  }
  .szh-menu__divider {
    margin: 0;
    background-color: var(--primary-200-relative);
  }

  .szh-menu__submenu > .szh-menu__item::after {
    content: "";
    position: absolute;
    right: 0;
  }

  .subMenu-item-template {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    .icon-label {
      display: flex;
      align-items: center;
      gap: 0.5rem;
    }

    .pi-angle-right {
      margin-left: 0.5rem;
    }
  }

  .department {
    .szh-menu__item--submenu {
      padding: 0;
      background-color: var(--primary-100-relative);
    }

    .szh-menu__divider.cvp-profile-concern-group-divider {
      margin: 0.35rem 0.75rem;
      height: 0;
      border-top: 1px solid var(--surface-d);
      background: none;
    }
  }

  .language-short-label {
    width: 1.7em;
    font-weight: 500;
    color: var(--surface-500);
  }

  .active,
  .active .language-short-label {
    color: var(--primary-500-relative);
    font-weight: bold;
  }

  // animation

  @keyframes szh-menu-show-slide-bottom {
    from {
      opacity: 0;
    }
  }

  @keyframes szh-menu-fade-out {
    to {
      opacity: 0;
    }
  }

  .szh-menu--state-opening.szh-menu--dir-bottom {
    animation: szh-menu-show-slide-bottom 120ms cubic-bezier(0, 0, 0.2, 1);
  }

  .szh-menu--state-closing.szh-menu--dir-bottom {
    animation: szh-menu-fade-out 0.1s linear forwards;
  }
`;
